"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingIcon = function LoadingIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "50",
    cy: "50",
    r: "40",
    stroke: "white",
    strokeWidth: "8",
    strokeLinecap: "round",
    strokeDasharray: "62.8 62.8",
    strokeDashoffset: "0",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "strokeDashoffset",
    values: "0;62.8",
    dur: "1s",
    repeatCount: "indefinite"
  })));
};

var _default = LoadingIcon;
exports["default"] = _default;